$(document).foundation();

$(document).ready(function () {
	// utils
	initVerticalCenter();
	initAnimateInView();
	inlineSVGs([
		'.header__burger img',
		'.footer__social img'
	]);
	initAnimimatedBorders();

	// global
	initHeader();
	initOffCanvas();
	initSliders();
	initPopup();
	initAnchors();

	// template specific
	initGallery();
	initAccordionListing();
	initGridListing();
	initCaseStudies();
	initServices();
	initTimeline();

	// Needs to fire after Slick-related code
	initLazyLoading();
});



function initVerticalCenter() {
	$('.vertical-center').each(function () {
		$(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
	});
}



function initAnimateInView() {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();

	$('.animated-border').append('<div class="animated-border-top"></div><div class="animated-border-right"></div><div class="animated-border-bottom"></div><div class="animated-border-left"></div>');
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		//console.log($(this));
		if ( isElementInViewport($(this)) ) {
			$(this).addClass( $(this).data('animate-in-view') ).addClass('in-view');
		}
	});
}


function initAnimimatedBorders() {

}

function isElementInViewport(el) {
	var rect = el[0].getBoundingClientRect();
	//var midPoint = rect.top + (rect.height / 2);
	var triggerPoint = rect.top + 100;


	if (
		( triggerPoint >= 0 ) &&
		( triggerPoint <= window.innerHeight )
	) {
		return true;
	} else {
		return false;
	}


	/*if ( rect.height > (window.innerHeight * 0.66) ) {
		// If its taller than 2/3rds of the screen then trigger earlier
		if ( rect.top <= window.pageYOffset ) {
			return true;
		} else {
			return false;
		}
	} else {
		// Check that center of the element is between top and bottom of window before animating
		if (
			( midPoint >= 0 ) &&
			( midPoint <= window.innerHeight )
		) {
			return true;
		} else {
			return false;
		}
	}*/


}




// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
	var selectorString = '';
	if (typeof inputValue === "object") {
		selectorString = inputValue.join(',');
	} else {
		selectorString = inputValue;
	}

	$(selectorString).each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		if (imgURL.indexOf('.svg') > -1) {
			$.get(imgURL, function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
				}

				// Replace image with new SVG
				$img.replaceWith($svg);
			}, 'xml');
		}
	});
}



function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function throttle(fn, threshhold, scope) {
	  threshhold || (threshhold = 250);
	  var last,
		  deferTimer;
	  return function () {
		var context = scope || this;

		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold) {
		  // hold on to it
		  clearTimeout(deferTimer);
		  deferTimer = setTimeout(function () {
			last = now;
			fn.apply(context, args);
		  }, threshhold);
		} else {
		  last = now;
		  fn.apply(context, args);
		}
	  };
	}


function initHeader() {


	// Detect if the header is over and image slider, if yes then give it a transparent background
	setHeaderTransparency();
	$(window).on('scroll', setHeaderTransparency);
	$('.header').show();

	function setHeaderTransparency() {
		if (window.pageYOffset < 150) {
			$('.header').removeClass('header--scrolled');

			if ( $('.slider').length > 0 ) {
				$('.header').addClass('header--transparent');
			}
		} else {
			$('.header').addClass('header--scrolled').removeClass('header--transparent');
		}
	}





}



function initOffCanvas() {
	//$('#offCanvas').foundation('open');

	$('.off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li><a href="' + overviewLink + '">Overview</a></li>');
		}
	});


	$('.off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item closes sub pages
				$(this).parent().removeClass('open');
				$(this).next().slideUp();
			} else {
				// close any other open items
				$('.off-canvas__nav-primary > ul > li.open').removeClass('open').find('.off-canvas__nav-sub').slideUp();

				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});
}








/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
function coverViewport(element, scaleToParent) {
	if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

	var viewportWidth, viewportHeight;
	if (scaleToParent) {
		viewportWidth = $(element).parent().innerWidth();
		viewportHeight = $(element).parent().innerHeight();
	} else {
		viewportWidth = $(window).innerWidth();
		viewportHeight = $(window).innerHeight();
	}

	var $element = $(element);

	var elementWidth = $element.attr('width');
	var elementHeight = $element.attr('height');

	// Aspect ratio = height / width
	var viewportRatio = viewportHeight / viewportWidth;
	var videoRatio = elementHeight / elementWidth;

	//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


	var newWidth = (elementWidth / elementHeight) * viewportHeight
	var newHeight = (elementHeight / elementWidth) * viewportWidth;
	var newTop = 0;

	if (viewportRatio > videoRatio) {
		// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
		//console.log('crop left and right');
		$element.css('height', viewportHeight);
		$element.css('width', newWidth);
		$element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
		$element.css('top', '0');
	} else if (viewportRatio < videoRatio) {
		// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
		//console.log('crop top and bottom');
		$element.css('width', viewportWidth);
		$element.css('height', newHeight);
		$element.css('left', '0');
		$element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
	} else {
		// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
		//console.log('no crop');
		$element.css('height', viewportHeight);
		$element.css('width', viewportWidth);
		$element.css('left', '0');
		$element.css('top', '0');
	}
}




function initSliders() {

	$('.slider__caption-big-text').each(function () {
		if ( $(this).text() === '' ) {
			$(this).siblings('.slider__caption-prev, .slider__caption-next').remove();
		}
	})

	$('.slider__inner').slick({
		autoplay: true,
		fade: true,
		autoplaySpeed: 5000,
		arrows: true,
		dots: false,
		prevArrow: $('.slider__caption-prev'),
		nextArrow: $('.slider__caption-next')
	});

	$('.slider__caption-prev, .slider__caption-next').on('mouseenter', function () {
		$('.slider__inner').slick('slickPause');
	});

	$('.slider__caption-prev, .slider__caption-next').on('mouseleave', function () {
		$('.slider__inner').slick('slickPlay');
	});

	if ( $('.slider__video').length > 0 ) {
		$('.slider').addClass('slider--has-video');
	}

	if ( $('.slider, .directions-map').length === 0 ) {
		pushContentBelowHeader()
		$(window).on('resize', pushContentBelowHeader);
	} else {
		$('body').addClass('has-slider');

		coverViewport($('.slider__video iframe'), true);
		$(window).on('resize', function () {
			coverViewport($('.slider__video iframe'), true);
		});
	}




	$('.promo-carousel__inner').slick({
		autoplay: false,
		fade: true,
		autoplaySpeed: 5000,
		arrows: true,
		dots: false,
		prevArrow: $('.promo-carousel__caption-prev'),
		nextArrow: $('.promo-carousel__caption-next')
	});





	$('.video-bar input[type="checkbox"]').on('change', function () {
		var iframeDesktop = $('.slider__video iframe');
		var playerDesktop = new Vimeo.Player(iframeDesktop);

		if ( $(this).prop('checked') ) {
			playerDesktop.setVolume(0);
			$('.slider__video .video-bar').addClass('off');
			$('.slider__video .video-bar').removeClass('on');
			$('.slider__video #volumeOff').css('visibility', 'visible');
			$('.slider__video #volumeOn').css('visibility', 'hidden');
		} else {
			playerDesktop.setVolume(0.66);
			$('.slider__video .video-bar').addClass('on');
			$('.slider__video .video-bar').removeClass('off');
			$('.slider__video #volumeOff').css('visibility', 'hidden');
			$('.slider__video #volumeOn').css('visibility', 'visible');
		}
	});
}



function pushContentBelowHeader() {
	$('main').css('padding-top', $('.header').outerHeight() + 'px');
}






function initPopup() {
	if ($('#popup').length > 0) {
		var popupDelay = $('#popup').data('popup-delay') || 0;
		var popupKeepHiddenFor = $('#popup').data('popup-keep-hidden-for-n-days') || 0;

		// Only show the popup if the cookie has not been seen, or always show it for testing in either local or remote markup
		if (
			(!Cookies.get('hasSeenPopup')) ||
			(location.hostname.indexOf('localhost') > -1) ||
			(location.hostname.indexOf('projects') > -1)
		) {
			setTimeout(function() {
				$('#popup').foundation('open');

				if (popupKeepHiddenFor > 0) {
					Cookies.set('hasSeenPopup', 'true', { expires: popupKeepHiddenFor });
				}
			}, popupDelay);
		}
	}
}



function initLazyLoading() {
	var lazyImages = Array.from($("[data-style], .lazy > source, .lazy-img"));

	var options = {
		root: null,
		rootMargin: "150px 0px",
		threshold: 0,
	  };

	var lazyImageObserver = new IntersectionObserver(callbackObserver, options);


	function presetImgSizeStyles(img) {
		if (
			img.nodeName === "SOURCE" ||
			img.nodeName === "DIV" ||
			img.classList.contains("bg-img") ||
			typeof img.dataset.presets !== "undefined"
		  ) {
			return;
		  }

		  img.style.width = "100%";
		  img.style.height = "auto";
		  img.style.display = "block";
		  img.decoding = "async";
	  }

	function setImageViewportWidth(img) {
		var windowWidth = window.innerWidth;
		var imgWidth = img.clientWidth;
		var imgViewportWidth = Math.floor((imgWidth / windowWidth) * 100) + "vw";
		img.sizes = imgViewportWidth;
	  }

	function handleImgSrcset(img) {
		setImageViewportWidth(img);
		img.srcset = img.dataset.srcset;
		img.src = img.dataset.src;
		delete img.dataset.srcset;
		delete img.dataset.src;
		lazyImageObserver.unobserve(img);

	  }

	function handleImgTag(img) {
		img.src = img.dataset.src;
		delete img.dataset.src;
		lazyImageObserver.unobserve(img);
	}

	function handleBackgroundImg(img) {
		img.style = img.dataset.style;
		delete img.dataset;
		lazyImageObserver.unobserve(img);
	  }

	function handlePictureElement(img) {
		if (img.nextElementSibling.nodeName === "IMG") {
		  img.nextElementSibling.src = img.nextElementSibling.dataset.src;
		  delete img.nextElementSibling.dataset.src;
		}

		img.srcset = img.dataset.srcset;
		delete img.dataset.srcset;

		img.parentElement.classList.remove("lazy");
		lazyImageObserver.unobserve(img);
	}

	function callbackObserver(entries) {
		entries.forEach(function(entry) {
		  var img = entry.target;

		  if (!entry.isIntersecting) return;

		  if (img.parentElement.nodeName === "PICTURE") {
			handlePictureElement(img);
		  }

		  if (img.nodeName === "IMG" && typeof img.dataset.srcset !== 'undefined') {
			handleImgSrcset(img);
		  }

		  if (img.nodeName === "IMG" && typeof img.dataset.srcset === "undefined") {
			handleImgTag(img);
		  }

		  if (img.nodeName === "DIV") {
			handleBackgroundImg(img);
		  }

		  lazyImageObserver.unobserve(img);
		});
	  }

	  lazyImages.forEach(function (img) {
		presetImgSizeStyles(img)
	  })

	  lazyImages.forEach(function (img) {
		lazyImageObserver.observe(img);
	  });
}



function initGallery() {


	$('.gallery__inner').append('<div class="gallery__scrollbar"><div class="gallery__scrollbar-thumb"></div></div><button class="gallery__next"></button>');

	$('.gallery__next').on('click', function () {
		$('.gallery__slider').slick('next');
	});

	var dragStarted = false;
	var dragStartMousePosition = 0;
	var dragStartThumbPosition = 0;
	var dragDistance = 0;

	$('.gallery__slider').on('init', function (event, slick) {
		setScrollbarThumbSize(this);
		$(window).on('resize', function () {
			setScrollbarThumbSize(this);
		});

		$carousel       = $(this);
		$scrollbar      = $(this).parent().find('.gallery__scrollbar');
		$scrollbarThumb = $(this).parent().find('.gallery__scrollbar-thumb');

		$scrollbarThumb.on('mousedown touchstart', function (event) {
			// Drag has started, so note the mouse starting position
			dragStarted = true;
			dragStartMousePosition = event.clientX;
			dragDistance = 0;
			$scrollbarThumb.css('transition-duration', '0s');
			dragStartThumbPosition = $scrollbarThumb.css('transform').split(/[()]/)[1].split(',')[4];
		});

		$(window).on('mouseup touchend', function (event) {
			if (!dragStarted) {
				return;
			}
			// Finished dragging, so clear temp vals and move the thumb to it's correct position
			dragStarted = false;
			$scrollbarThumb.css('transition-duration', '0.3s');

			var slideCount = $carousel.parent().find('.slick-dots li').length;
			var scrollbarWidth = $carousel.parent().find('.gallery__scrollbar').outerWidth();
			var thumbWidth = scrollbarWidth / slideCount;
			var dragEndPosition = $scrollbarThumb.css('transform').split(/[()]/)[1].split(',')[4];

			var dragEndIndex = Math.floor((dragEndPosition / scrollbarWidth) * 10);
			if (dragEndIndex < 0) {
				dragEndIndex = 0;
			} else if (dragEndIndex >= slideCount) {
				dragEndIndex = slideCount-1;
			}

			// finally tell slick what slide to change to
			$carousel.slick('slickGoTo', dragEndIndex, false);
		});

		$(window).on('mousemove touchmove', function (event) {
			if (dragStarted) {
				dragDistance = event.clientX - dragStartMousePosition;
				var newPosition = (event.clientX - dragStartMousePosition) + dragStartThumbPosition*1;

				// Stop it from dragging outside the scrollbar
				if ((newPosition >= 0) && (newPosition < ($scrollbar.outerWidth() - $scrollbarThumb.outerWidth()))) {
					$scrollbarThumb.css('transform', 'translateX(' + (dragDistance + dragStartThumbPosition *1) + 'px)');
				}
			}
		});
	});

	$('.gallery__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		setScrollbarThumbPosition(this, nextSlide);
	});

	$('.gallery__slider').slick({
		arrows: true,
		dots: true
	});

	function setScrollbarThumbSize(carousel) {
		// Divide the width of the scrollbar by the number of slides to get the width of the thumb
		var slideCount = $(carousel).parent().find('.slick-dots li').length;
		var scrollbarWidth = $(carousel).parent().find('.gallery__scrollbar').outerWidth();
		var thumbWidth = scrollbarWidth / slideCount;
		$(carousel).parent().find('.gallery__scrollbar-thumb').css('width', thumbWidth);
	}

	function setScrollbarThumbPosition(carousel, nextSlideIndex) {
		// Move the thumb to the correct notch for the current slide index
		var slideIndex;
		if (typeof nextSlideIndex === 'undefined') {
			slideIndex = nextSlideIndex;
		} else {
			slideIndex = $(carousel).slick('slickCurrentSlide');
		}
		var scrollbarThumbWidth = $(carousel).parent().find('.gallery__scrollbar-thumb').outerWidth();
		var thumbPosition = nextSlideIndex * scrollbarThumbWidth;
		$(carousel).parent().find('.gallery__scrollbar-thumb').css('transform', 'translateX(' + thumbPosition + 'px)');
	}






}



function initAccordionListing() {
	// DIY Accordion:
	// Append toggle buttons
	$('.accordion-listing__item').each(function () {
		if ( $(this).find('.accordion-listing__item-content-more').length > 0 ) {
			$(this).find('.accordion-listing__item-buttons').prepend('<button class="button">Read More</button><br />');
		}
	});

	// Toggle button event
	$('.accordion-listing__item-buttons button').on('click', function () {
		if ( $(this).hasClass('on') ) {
			// User is closing the current open item
			$(this).removeClass('on').text('Read More');
			$(this).parents('.accordion-listing__item-content').find('.accordion-listing__item-content-more').slideUp();
		} else {
			// User is opening a new item.
			// first close any other open ones that might exist
			$('.accordion-listing__item-content-more').slideUp();
			$('.accordion-listing__item-buttons button.on').text('Read More').removeClass('on');

			// Now open this one.
			$(this).addClass('on').text('Read Less');
			$(this).parents('.accordion-listing__item-content').find('.accordion-listing__item-content-more').slideDown();
		}
	});
}




function initGridListing() {
	$('.grid-listing__filters select').selectric();

	$('.grid-listing').append('<div class="grid-listing__filter-error cell text-center" style="display: none;"><p>No results match your selected filters</p></div>');

	$('.grid-listing').on('filter-changed', function () {
		$('.grid-listing__filters select').selectric('refresh');

		var count = 0;
		var offsetClasses, maxCount;

		if ( $('.grid-listing').hasClass('group') ) {
			offsetClasses = ['filtered-left', 'filtered-right'];
			maxCount = 1;
		} else {
			offsetClasses = ['filtered-left', 'filtered-middle', 'filtered-right'];
			maxCount = 2;
		}

		$('.grid-listing__item').each(function () {
			$(this).removeClass('filtered-left filtered-middle filtered-right');
			$(this).addClass( $(this).data('animate-in-view') ).addClass('in-view');

			if ( $(this).hasClass('filter-multi-item-visible') ) {
				$(this).addClass( offsetClasses[count] );
				count++;
				if ( count > maxCount) count = 0;
			}
		});

		if ( $('.filtered-left, .filtered-middle, .filtered-right').length === 0 ) {
			$('.grid-listing__filter-error').show();
		} else {
			$('.grid-listing__filter-error').hide();
		}
	});


	// Custom equalizer
	// if ( window.innerWidth > 640 ) {
	// 	var tallestHeight = 0;
	// 	$('.grid-listing .grid-listing__item-content > div').each(function () {
	// 		if ( $(this).outerHeight() > tallestHeight ) {
	// 			tallestHeight = $(this).outerHeight();
	// 		}
	// 	});
	// 	tallestHeight += 20;
	// 	$('.grid-listing .grid-listing__item-content > div').css('height', tallestHeight + 'px');
	// }
}



function initCaseStudies() {
	$('.case-studies__accordion').accordiom({
		showFirstItem: false
	});
}


function initServices() {
	$('.services__carousel-inner').each(function () {
		var maxSlidesToShowLarge = 3;
		var maxSlidesToShowMedium = 2;

		if ( $(this).find('img').length < 2 ) {
			maxSlidesToShowLarge = 1;
			maxSlidesToShowMedium = 1;
			$(this).addClass('one-image');
		} else if ( $(this).find('img').length < 3 ) {
			maxSlidesToShowLarge = 2;
			$(this).addClass('two-images');
		}

		$(this).slick({
			arrows: true,
			slidesToShow: maxSlidesToShowLarge,
			centerMode: true,
			centerPadding: '0',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: maxSlidesToShowMedium
					}
				},
				{
					breakpoint: 640,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	});
}



function initAnchors() {
	// Nicely scroll if deep linked to an anchor
	if ( window.location.hash !== '' ) {
		$('.anchors a[href="' + window.location.hash + '"]').trigger('click');

		$('[data-animate-in-view]').each(function () {
			$(this).addClass( $(this).data('animate-in-view') );
		});


		// "skip" is a special anchor to skip below any slider to get to the content
		if ( window.location.hash === '#skip' ) {
			$('html, body').animate({
				scrollTop: window.innerHeight
			}, 0);

			return;
		}

		var anchorName = window.location.hash.replace('#', '');
		anchorName = anchorName.replace('%20', ' ');
		if ( $('a[name="' + anchorName + '"]').length === 0 ) {
			return;
		}



		// Delay to allow for scrolling animations
		var waitForAnimations = 1500;
		if ( $('.contact__details').length > 0 ) {
			waitForAnimations = 0;
		}

		setTimeout(function () {
			var scrollToPos = $('a[name="' + anchorName + '"]').first().parent().offset().top;

			if (typeof scrollToPos !== 'undefined') {
				scrollToPos -= $('.header').outerHeight();
				//scrollToPos += 100;


				$('html, body').animate({
					scrollTop: scrollToPos
				}, 0);
			}
		}, waitForAnimations);
	}



	$('.back-to-top').on('click', function(e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $('#main-content').offset().top
		}, 1000);
	});

}


// Custom newsletter form code
// Need to change the IDs of the fields in the burger menu to be different from the footer form
$('#offCanvas #FIRSTNAME').attr('id', 'FIRSTNAME_offcanvas').prev('label').attr('for', 'FIRSTNAME_offcanvas');
$('#offCanvas #email').attr('id', 'email_offcanvas').prev('label').attr('for', 'email_offcanvas');
$('#offCanvas #ci_userConsentCheckBox').attr('id', 'ci_userConsentCheckBox_offcanvas').next('label').attr('for', 'ci_userConsentCheckBox_offcanvas');

function checkbox_Clicked(element) {
	document.getElementById(element.id + "_unchecked").value = !element.checked;
}
function validate_signup(frm, showAlert) {
	var emailAddress = frm.email.value;
	var errorString = '';
	if (emailAddress == '' || emailAddress.indexOf('@') == -1) {
		errorString = 'Please enter your email address';
	}
	var checkBoxValue = frm.ci_userConsentCheckBox.checked;
	if (checkBoxValue == false && showAlert) {
		errorString = 'You must accept the terms';
	}
	if (showAlert) {
		var els = frm.getElementsByTagName('input');
		for (var i = 0; i < els.length; i++) {
			if (els[i].className == 'text' || els[i].className == 'date' || els[i].className == 'number') {
				if (els[i].value == '') errorString = 'Please complete all required fields.';
			} else if (els[i].className == 'radio') {
				var toCheck = document.getElementsByName(els[i].name);
				var radioChecked = false;
				for (var j = 0; j < toCheck.length; j++) {
					if (toCheck[j].name == els[i].name && toCheck[j].checked) radioChecked = true;
				}
				if (!radioChecked) errorString = 'Please complete all required fields.';
			}
		}
	}
	var isError = false;
	if (errorString.length > 0) {
		isError = true;
		if (showAlert) alert(errorString);
	}
	return !isError;
}

function initTimeline() {
    // Custom up/down arrows which update to show the next/previous years within the text of the button
    $('.timeline__items').on('afterChange', function (event, slick, currentSlide) {
        var prevYear = slick.$slides.filter('.slick-current').prev().data('year') || '';
        var nextYear = slick.$slides.filter('.slick-current').next().data('year') || '';

        $('.timeline__items-prev-year').text(prevYear);
        $('.timeline__items-next-year').text(nextYear);
    });
	
	$('.timeline__items').on('setPosition', function(event, slick) {
		if ( $(window).innerWidth() < 640 ) {
			$('.timeline__nav').css('top', $('.timeline__items img').first().outerHeight() + 'px');
		} else {
			$('.timeline__nav').css('top', '0');
		}
	});

    $('.timeline__items').slick({
        vertical: true,
        slidesToShow: 1,
        verticalSwiping: false,
        infinite: false,
        draggable: false,
        asNavFor: $('.timeline__nav'),
        prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
        responsive: [
            {
                breakpoint: 641,
                settings: {
                    vertical: false,
                    adaptiveHeight: true
                }
            }
        ]
    });

    // Grab the value of the second year and put that into the next button
    $('.timeline__items-next-year').text($('.timeline__item:eq(1)').data('year'));

    $('.timeline__nav').slick({
        vertical: true,
        slidesToShow: 5,
        verticalSwiping: false,
        infinite: false,
        asNavFor: $('.timeline__items'),
        responsive: [
            {
                breakpoint: 640,
                settings: 'unslick'
            },
        ],
    });

    // Move to the chosen year when clicking on one of the nav buttons
    $('.timeline__year button').on('click', function (e) {
        e.preventDefault();
        $('.timeline__items').slick('slickGoTo', $(this).parents('.slick-slide').data('slick-index'));
    });
}

function initFooterSlick() {
	$('.footer-logos__inner').slick({
		// dots: true,
		infinite: true,
		slidesToShow: 2,
		// centerMode: true,
		variableWidth: true,
		mobileFirst: true,
		arrows: true,
		nextArrow: '.right',
		prevArrow: '.left',
		responsive: [{
			breakpoint: 640,
			settings: 'unslick'
		}],
	});
}



$(document).ready(function() {

	initFooterSlick();

	var $slider = $('.footer-logos__inner');
	var $progressBar = $('.progress');
	
	$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
	  var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
	  
	  $progressBar
		.css('background-size', calc + '% 100%')
		.attr('aria-valuenow', calc );
	  
	});


	// listen to jQuery's window resize
	$(window).on('resize', function(){

        var width = $(window).width();

        if (width < 640) {
          // reinit slick while window's width is less than maximum width (641px)
          initFooterSlick();
        }
    });
	
});

// responsive: [
// 	{
// 		breakpoint: 767,
// 		settings: "unslick"
// 	}
// ]